import { render, staticRenderFns } from "./PlayImg.vue?vue&type=template&id=2cd131f2&scoped=true"
import script from "./PlayImg.vue?vue&type=script&lang=js"
export * from "./PlayImg.vue?vue&type=script&lang=js"
import style0 from "./PlayImg.vue?vue&type=style&index=0&id=2cd131f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd131f2",
  null
  
)

export default component.exports